import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { setActionConfirmationsEnabled } from '../actions/internalActions';

mutator(setActionConfirmationsEnabled, actionMessage => {
    getStore().actionConfirmationsEnabled = actionMessage.isEnabled;
});
